import { create } from 'zustand'
import { UserProfile } from '@/shared/api'

interface AuthState {
  // State
  user: UserProfile | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  
  // Actions
  setUser: (user: UserProfile | null) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearError: () => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  // Initial state
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,

  // Actions
  setUser: (user: UserProfile | null) => {
    set({
      user,
      isAuthenticated: !!user,
      error: null
    })
  },

  setLoading: (isLoading: boolean) => {
    set({ isLoading })
  },

  setError: (error: string | null) => {
    set({ error })
  },

  clearError: () => {
    set({ error: null })
  },

  logout: () => {
    set({
      user: null,
      isAuthenticated: false,
      error: null
    })
  }
}))

// Selector hooks for better performance
export const useUser = () => useAuthStore(state => state.user)
export const useIsAuthenticated = () => useAuthStore(state => state.isAuthenticated)
export const useIsLoading = () => useAuthStore(state => state.isLoading)
export const useAuthError = () => useAuthStore(state => state.error)

// Direct action hooks to avoid object creation
export const useSetUser = () => useAuthStore(state => state.setUser)
export const useSetLoading = () => useAuthStore(state => state.setLoading)
export const useSetError = () => useAuthStore(state => state.setError)
export const useClearError = () => useAuthStore(state => state.clearError)
export const useLogout = () => useAuthStore(state => state.logout)
